import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { useGetMyProfile } from "@/api/queries";
import { str } from "@/helpers/str";

import type { UseSettingsFormReturn } from "../types/settings.types";
import type { SettingsFormValues } from "../utils/settingsSchema";

import { settingsSchema } from "../utils/settingsSchema";

export default function useSettingsForm(): UseSettingsFormReturn {
  const profile = useGetMyProfile();

  const form = useForm<SettingsFormValues>({
    resolver: zodResolver(settingsSchema),
    defaultValues: {
      firstname: "",
      lastname: "",
      addressline1: "",
      addressline2: "",
      addressline3: "",
      towncity: "",
      countystate: "",
      postzipcode: "",
      phonenumber: "",
      countrycode: "",
    },
  });

  useEffect(() => {
    if (profile.isSuccess) {
      const d = profile.data;
      form.reset({
        firstname: str(d.firstname),
        lastname: str(d.lastname),
        addressline1: str(d.addressline1),
        addressline2: str(d.addressline2),
        addressline3: str(d.addressline3),
        towncity: str(d.towncity),
        countystate: str(d.countystate),
        postzipcode: str(d.postzipcode),
        phonenumber: str(d.phonenumber),
        countrycode: str(d.countrycode),
      });
    }
  }, [profile.isSuccess, profile.data, form]);

  return { form, profile };
}
